// extracted by mini-css-extract-plugin
export default {"filterIcon":"KeyDealsTab_filterIcon__yzt2w","add-icon":"KeyDealsTab_add-icon__PwXoS","no-deal-icon":"KeyDealsTab_no-deal-icon__xxg7P","icon-24":"KeyDealsTab_icon-24__uE9A9"};